import PlaylistSharedView from './PlaylistSharedView'

export default PlaylistSharedView
